import { useRef } from 'react'
import Tooltip from '@material-ui/core/Tooltip'

import { ReactComponent as EmptyImage } from 'assets/icons/IconEmptyImage.svg'
import { ReactComponent as IconPencil } from 'assets/icons/IconEditPencil.svg'
import { ReactComponent as IconTrash } from 'assets/icons/IconTrash.svg'
import { ReactComponent as IconAlert } from 'assets/icons/IconAlert.svg'

const ImageUploader = ({
  onDragAndDropChange,
  onImageChange,
  onRemoveImage,
  image,
  infoText = '',
}) => {
  const fileInputRef = useRef(null)

  const handleDragOver = (event) => {
    event.preventDefault()
  }

  const handleChooseImage = (event) => {
    event.preventDefault()
    fileInputRef.current.click()
  }

  if (!image) {
    return (
      <div
        className="image-uploader"
        onDragOver={handleDragOver}
        onDrop={onDragAndDropChange}
      >
        <EmptyImage className="image-uploader__empty-image-icon" />
        <span className="image-uploader__drop-files-text">
          Drag and Drop file here
        </span>
        <span className="image-uploader__text-specs">
          Recommended Image Size: 740 x 492 <br /> Files Supported:
          PNG, JPG
        </span>
        <button
          className="image-uploader__upload-button"
          onClick={handleChooseImage}
        >
          Choose Image
        </button>
        <input
          className="image-uploader__upload-input"
          ref={fileInputRef}
          id="fileInput"
          value={image}
          type="file"
          accept="image/*"
          onChange={onImageChange}
        />
      </div>
    )
  }

  return (
    <div
      className="image-loaded"
      onDragOver={handleDragOver}
      onDrop={onDragAndDropChange}
    >
      <div
        className="image-loaded__selected-image"
        style={{
          backgroundImage: `url(${URL.createObjectURL(image)})`,
        }}
      >
        <div className="image-loaded__alert-box">
          <Tooltip title={infoText} arrow placement="top">
            <IconAlert />
          </Tooltip>
        </div>
        <div className="image-loaded__buttons-box">
          <button
            className="image-loaded__icon-button"
            onClick={handleChooseImage}
          >
            <Tooltip
              title="Click to open system dialog for uploading an image"
              arrow
              placement="top"
            >
              <IconPencil />
            </Tooltip>
          </button>
          <input
            className="image-uploader__upload-input"
            ref={fileInputRef}
            id="fileInput"
            type="file"
            accept="image/png, image/jpg"
            onChange={onImageChange}
          />
          {/* <button
            className="image-loaded__icon-button"
            onClick={onRemoveImage}
          >
            <Tooltip
              title="Click to immediately delete the current image"
              arrow
              placement="top"
            >
              <IconTrash />
            </Tooltip>
          </button> */}
        </div>
      </div>
    </div>
  )
}

export default ImageUploader
